// React things
import React, { useEffect, useState } from "react";
import axios from "axios";
import { settings } from "../../Services/Requests.ts";
// Styles
import style from "./Coin.module.css";

export default function Coin(props) {
  const [activeCharacter, setActiveCharacter] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const tg = window.Telegram.WebApp;

  useEffect(() => {
    const getCharacters = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(`${settings.url}api/characters`);

        if (
          response.data.owned_characters &&
          response.data.owned_characters.length > 0
        ) {
          const active = response.data.owned_characters.find(
            (char) => char.is_active
          );
          if (active) {
            setActiveCharacter(active);
          } else {
            setError("Активный персонаж не найден");
          }
        } else {
          setError("Нет доступных персонажей");
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setIsLoading(false);
        if (typeof props?.setLoading === "function") {
          props.setLoading(false);
        }
      }
    };

    getCharacters();
  }, []);

  if (isLoading) {
    return (
      <div className={style.loadingContainer}>
        <div className={style.loadingSpinner}></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={style.errorContainer}>
        <p>Ошибка: {error}</p>
      </div>
    );
  }

  if (!activeCharacter) {
    return (
      <div className={style.errorContainer}>
        <p>Персонаж не найден</p>
      </div>
    );
  }

  return (
    <div className={style.characterContainer}>
      <img
        src={activeCharacter.character.full_icon_url}
        alt={activeCharacter.character.name}
        className={style.characterImage}
        onLoad={() => console.log()}
        onError={(e) => {
          console.error("Ошибка загрузки изображения:", e);
          setError("Ошибка загрузки изображения");
        }}
      />
    </div>
  );
}
